var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"post"},[_c('h3',{staticClass:"post-title"},[_vm._v(_vm._s(_vm.props.article.title))]),_c('v-lazy-image',{staticClass:"image",attrs:{"src":_vm.props.article.imagePathFullSize,"src-placeholder":_vm.props.article.imagePath,"alt":_vm.props.article.imageAlt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }